/**
 * @brief 视图语言包
 * @date 2025年07月08日17:27:02
 */
export default {
  视图预览: '视图预览',
  '注：预览区的数据为样例数据。': '注：预览区的数据为样例数据。',
  视图配置: '视图配置',
  新建视图: '新建视图',
  外部视图: '外部视图',
  看板: '看板',
  外部页面: '外部页面',
  自定义范围: '自定义范围',
  应用场景: '应用场景',
  PC端: 'PC端',
  移动端: '移动端',
  显示方式: '显示方式',
  显示全部字段: '显示全部字段',
  与PC端保持一致: '与PC端保持一致',
  最多显示个数: '最多显示个数',
  请输入最多显示个数: '请输入最多显示个数',
  '请输入完整的页面链接，以http或https开头，否则将无法保存': '请输入完整的页面链接，以http或https开头，否则将无法保存',
  '请输入完整的页面链接，以https开头，否则将无法保存': '请输入完整的页面链接，以https开头，否则将无法保存',
  '请输入完整的页面链接，以http或https开头': '请输入完整的页面链接，以http或https开头',
  '请输入完整的页面链接，以https开头': '请输入完整的页面链接，以https开头',
  开启自定义显示列提示: '开启自定义显示列提示',
  '调整显示列设置后，所选字段排序将不再跟随表单设计也字段排布顺序变化，后续新增字段需要手动调整显示列排序位置，是否确定保存？': '调整显示列设置后，所选字段排序将不再跟随表单设计也字段排布顺序变化，后续新增字段需要手动调整显示列排序位置，是否确定保存？',
  '创建视图中，请稍后': '创建视图中，请稍后',
  请选择排序字段: '请选择排序字段',
  分组字段: '分组字段',
  请设置分组字段: '请设置分组字段',
  选择分组字段: '选择分组字段',
  请选择分组字段: '请选择分组字段',
  '选择一个字段作为“分组”，数据将按照此字段中的字段值分组显示在看板中。仅支持单选、下拉单选和人员类型字段。': '选择一个字段作为“分组”，数据将按照此字段中的字段值分组显示在看板中。仅支持单选、下拉单选和人员类型字段。',
  表格视图: '表格视图',
  看板视图: '看板视图',
  卡片配置: '卡片配置',
  显示全部: '显示全部',
  隐藏全部: '隐藏全部',
  隐藏字段名: '隐藏字段名',
  分组方式: '分组方式'
};
